export default __webpack_public_path__ + "static/media/key.0b496e93.svg";